import { connect } from 'react-redux';
import Advert from 'app/components/commons/Advert';
import makeAdvertsSelector from 'app/selectors/advertsSelector';

function makeMapStateToProps() {
  const advertsSelector = makeAdvertsSelector();

  return (state, props) => ({
    items: advertsSelector(state, props),
  });
}

export default connect(makeMapStateToProps, null)(Advert);
